import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=899f8f7c&scoped=true&"
import script from "./Buffer.vue?vue&type=script&lang=js&"
export * from "./Buffer.vue?vue&type=script&lang=js&"
import style0 from "./Buffer.vue?vue&type=style&index=0&id=899f8f7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f8f7c",
  null
  
)

export default component.exports